import { combineReducers } from "@reduxjs/toolkit";

import { accountReducer } from "./accountSlice";

export const adminReducer = combineReducers({
  account: accountReducer,
});
